import { Bouncer } from "./Bouncer";
export async function loadExternalBounceInteraction(engine) {
    await engine.addInteractor("externalBounce", (container) => new Bouncer(container));
}
export * from "./Options/Classes/Bounce";
export * from "./Options/Interfaces/IBounce";
